import {
  GetExamCenterByExamCenterCodeDocument,
  useUpdateExamCenterMutation,
} from '@exam-center/graphql';
import { useSnackbar } from '@shared/snackbar';
import { zodResolver } from '@shared/utils';
import { useForm } from 'react-hook-form';

import { ExamCenterDetailsForm } from '../../components';
import { useExamCenter } from '../../providers';

import {
  ExamCenterDetailsFormSchema,
  type ExamCenterDetailsFormInput,
} from './exam-center-detail-form-schema';
import { mapExamCenterDetailsDefaultFormValues } from './mapper';

export default function ExamCenterDetailsFormLogic() {
  const { examCenter } = useExamCenter();
  const { showSnackbar } = useSnackbar();

  const formContext = useForm({
    defaultValues: mapExamCenterDetailsDefaultFormValues(examCenter),
    resolver: zodResolver(ExamCenterDetailsFormSchema),
  });

  const { code, nameTH, nameEN } = examCenter;

  const [updateExamCenter] = useUpdateExamCenterMutation();

  const handleSubmit = async (data: ExamCenterDetailsFormInput) => {
    await updateExamCenter({
      variables: {
        updateExamCenterInput: {
          examCenterCode: examCenter.code,
          addressTH: data.addressTH,
          addressEN: data.addressEN,
          phoneTH: data.phoneTH,
          phoneEN: data.phoneEN,
          email: data.email,
          examResultRecipientEmail: data.examResultRecipientEmail,
          website: data.website,
        },
      },
      refetchQueries: [
        {
          query: GetExamCenterByExamCenterCodeDocument,
          variables: {
            getExamCenterByExamCenterCodeInput: {
              examCenterCode: examCenter.code,
            },
          },
        },
      ],
      awaitRefetchQueries: true,
      onCompleted: () => {
        showSnackbar({ message: 'บันทึกข้อมูลศูนย์ทดสอบเรียบร้อยแล้ว', variant: 'success' });
        formContext.reset(formContext.getValues());
      },
      onError: () => {
        showSnackbar({ message: 'เกิดข้อผิดพลาดในการแก้ไขข้อมูลศูนย์ทดสอบ', variant: 'error' });
      },
    });
    return data;
  };

  return (
    <ExamCenterDetailsForm
      code={code}
      nameTH={nameTH}
      nameEN={nameEN}
      form={formContext}
      onSubmit={handleSubmit}
    />
  );
}
